/**
 * Formatters — pure Funktionen für Display-Strings.
 */

export function formatTime(ms) {
  if (ms == null || ms < 0) return '—';
  const s = (ms / 1000).toFixed(1);
  return `${s}s`;
}

export function formatScore(score) {
  return String(score).padStart(4, '0');
}

export function getInitials(name) {
  if (!name) return '??';
  return name
    .split(/\s+/)
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function getRankBadge(rank) {
  if (rank === 1) return '🥇';
  if (rank === 2) return '🥈';
  if (rank === 3) return '🥉';
  return `#${rank}`;
}

export function getCategoryLabel(cat) {
  const map = {
    sequences: 'Folgen',
    equations: 'Gleichungen',
    logic:     'Logik',
    patterns:  'Muster',
    visual:    'Visuell',
  };
  return map[cat] || cat;
}

export function getDifficultyLabel(diff) {
  return ['', 'Easy', 'Medium', 'Hard', 'Expert'][diff] || 'Unknown';
}
